// SPDX-License-Identifier: GPL-3.0-or-later

// Воспроизведение входящих MediaStream через скрытые <audio autoplay> элементы.
// WebRTC-трек сам по себе не звучит — нужен <audio srcObject=stream>. ViewModel держит только
// логику, а играет звуки этот сервис, DOM-специфичный (поэтому здесь, а не в viewmodels).

export interface RemoteAudioSinkService {
  play(id: string, stream: MediaStream): void;
  stop(id: string): void;
  stopAll(): void;
}

export class HtmlRemoteAudioSinkService implements RemoteAudioSinkService {
  private elements = new Map<string, HTMLAudioElement>();

  play(id: string, stream: MediaStream): void {
    let el = this.elements.get(id);
    if (!el) {
      el = document.createElement('audio');
      el.autoplay = true;
      // playsInline важен для iOS Safari и Electron — без него поток может не стартовать.
      el.setAttribute('playsinline', 'true');
      el.style.display = 'none';
      document.body.appendChild(el);
      this.elements.set(id, el);
    }
    el.srcObject = stream;
    // play() может отклониться из-за autoplay-политики — игнорируем, autoplay=true уже запустит.
    void el.play().catch(() => undefined);
  }

  stop(id: string): void {
    const el = this.elements.get(id);
    if (!el) return;
    try {
      el.srcObject = null;
      el.remove();
    } catch {
      /* уже удалён */
    }
    this.elements.delete(id);
  }

  stopAll(): void {
    for (const id of [...this.elements.keys()]) this.stop(id);
  }
}
